import { render, staticRenderFns } from "./AssessmentScore.vue?vue&type=template&id=2a44d8c7"
import script from "./AssessmentScore.vue?vue&type=script&lang=js"
export * from "./AssessmentScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports